// Tracker #257 follow-up (JD, 10/13): changing the selected policies used to wipe every cell on
// the form, including numbers, dates and carriers the agent had typed. Now each cell remembers
// the last value the machine (clear, get-coverages prefill, edit restore) wrote to it:
//   - a cell still holding that machine value is machine-owned and gets cleared or replaced
//   - a cell the agent changed is agent-owned and survives, unless the new policy data has a
//     value for that same cell, in which case the policy data wins
// Use it as a functional setState updater so the comparison sees the live value, not a stale
// closure: setCglPolicyNumber(own('CglPolicyNumber', next)).

const isEmpty = (v: unknown) => v === '' || v === null || v === undefined || v === false;
const same = (a: unknown, b: unknown) =>
  a instanceof Date && b instanceof Date ? a.getTime() === b.getTime() : a === b;

export interface MachineOwned {
  // prev is typed loosely so a `null` or `''` next does not narrow the setter's state type.
  own: <V>(key: string, next: V) => (prev: any) => V;
  /** Forget every machine value (a fresh form). */
  reset: () => void;
}

export function createMachineOwned(): MachineOwned {
  const last: Record<string, unknown> = {};
  return {
    own: <V,>(key: string, next: V) => (prev: any): V => {
      const agentOwned = !isEmpty(prev) && !same(prev, last[key]);
      last[key] = next;
      return agentOwned && isEmpty(next) ? prev : next;
    },
    reset: () => { Object.keys(last).forEach(k => { delete last[k]; }); },
  };
}
